import { render, staticRenderFns } from "./goodsPair.vue?vue&type=template&id=8681c296"
import script from "./goodsPair.vue?vue&type=script&lang=js"
export * from "./goodsPair.vue?vue&type=script&lang=js"
import style0 from "./goodsPair.vue?vue&type=style&index=0&id=8681c296&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports